/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * First line of the address
     * @type {string}
     * @memberof Address
     */
    addressLine1?: string;
    /**
     * Second line of the address
     * @type {string}
     * @memberof Address
     */
    addressLine2?: string | null;
    /**
     * City name
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * State or province
     * @type {string}
     * @memberof Address
     */
    state?: string | null;
    /**
     * Postal or ZIP code
     * @type {string}
     * @memberof Address
     */
    postalCode?: string | null;
    /**
     * Country name
     * @type {string}
     * @memberof Address
     */
    countryName?: string;
    /**
     * Country code (ISO Alpha-2)
     * @type {string}
     * @memberof Address
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryName': json['countryName'] == null ? undefined : json['countryName'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

  export function AddressToJSON(json: any): Address {
      return AddressToJSONTyped(json, false);
  }

  export function AddressToJSONTyped(value?: Address | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'city': value['city'],
        'state': value['state'],
        'postalCode': value['postalCode'],
        'countryName': value['countryName'],
        'countryCode': value['countryCode'],
    };
}

